import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch";
import * as createResponseHandling from "./../responseHandling/create";
import * as deleteResponseHandling from "./../responseHandling/delete";

async function fetchLessonModules(lessonId) {
  // This API call returns both the lesson and the lesson's lesson modules
  const res = await axios.get(`/students/lesson_modules/${lessonId}`);
  if (res.status === 200) {
    res.data.lesson_modules.sort((a, b) => a.position - b.position);
    return res.data;
  }
  return fetchResponseHandling.parseResponse(res);
}

async function answeredLessonTriggerQuestion(body) {
  const res = await axios.post(`/students/lesson_trigger_module_answers`, body);
  return createResponseHandling.parseResponse(res);
}

async function answeredLessonFillInTheBlankQuestion(body) {
  // body should be:
  // {
  //   id: "lesson_id",
  //   lesson_fill_in_the_blank_answer: {
  //     answer: '["contango"]',
  //     lesson_fill_in_the_blank_module_id: "module_id"
  //   }
  // }

  const res = await axios.post(`/students/lesson_fill_in_the_blank_answers`, body);
  return createResponseHandling.parseResponse(res);
}

async function answeredLessonMultipleChoiceQuestion(body) {
  // body should be:
  // {
  //   id: "lesson_id",
  //   lesson_module_multiple_choice_answer: {
  //     lesson_multiple_choice_question_module_id: "lesson module id",
  //     answer: "integer representing answer - can be anything you want it to be mike. frontend intreprets the number. backend is dumb to this value"
  //   }
  // }

  const res = await axios.post(`/students/lesson_module_multiple_choice_answers`, body);
  return createResponseHandling.parseResponse(res);
}

export {
  fetchLessonModules,
  answeredLessonTriggerQuestion,
  answeredLessonMultipleChoiceQuestion,
  answeredLessonFillInTheBlankQuestion,
}
